import { Card } from "@shared/ui/card";
import { PageHeader } from "@shared/components/PageHeader";
import { Banknote, DollarSign, History } from "lucide-react";
import ApplicationProcessFeesCreate from "../create/create";
import { Button } from "@shared/ui/button";
import { useState } from "react";
import FeesHistoryModal from "../feesHistoryModal/feesHistoryModal";

const ApplicationProcessFeesLanding = () => {
  const [openFeesHistoryModal, setOpenFeesHistoryModal] = useState(false);
  return (
    <Card>
      <div className="flex justify-between">
        <PageHeader
          icon={Banknote}
          title="Application Processing Fees by Consumer Category"
          subtitle="Configure payment line items for different consumer categories. Each category can have its own fee structure."
        />
        <Button
          variant="outline"
          className="flex items-center gap-2"
          onClick={() => setOpenFeesHistoryModal(true)}
        >
          <History className="h-5 w-5" />
          Fees History
        </Button>
      </div>
      <div className="mt-4">
        <ApplicationProcessFeesCreate />
      </div>

      <FeesHistoryModal
        openModal={openFeesHistoryModal}
        setOpenModal={setOpenFeesHistoryModal}
      />
    </Card>
  );
};

export default ApplicationProcessFeesLanding;
